"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _item, _content;

  return {
    item: (_item = {
      background: theme.palette.grey[300],
      display: "flex",
      flexDirection: "column",
      height: "100%",
      position: "relative"
    }, _defineProperty(_item, theme.breakpoints.up("md"), {
      background: "none",
      display: "grid",
      flexDirection: "unset",
      gridTemplateColumns: "50% 50%",
      gridTemplateRows: "1fr 1fr 80px"
    }), _defineProperty(_item, theme.breakpoints.up("lg"), {
      gridTemplateColumns: "60% 40%",
      gridTemplateRows: "1fr 1fr 100px"
    }), _item),
    image: _defineProperty({}, theme.breakpoints.up("md"), {
      gridRow: "1 / -1"
    }),
    content: (_content = {
      background: theme.palette.grey[300],
      display: "flex",
      flexDirection: "column",
      height: "100%",
      padding: theme.spacing(3, 2),
      userSelect: "none"
    }, _defineProperty(_content, theme.breakpoints.up("md"), {
      gridRow: "1 / 3",
      height: "auto",
      padding: theme.spacing(4, 4, 10)
    }), _defineProperty(_content, theme.breakpoints.up("lg"), {
      padding: theme.spacing(7, 7, 12)
    }), _content),
    text: {
      marginTop: theme.spacing(2)
    }
  };
});
var _default = styles;
exports.default = _default;